import React, {Fragment, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchSettingsJSON, setFullLockout} from "apps/DRAW_PREDICTOR/modules/actions";
import {getDrawPredictorSettings, isFullLockout} from "apps/DRAW_PREDICTOR/modules/selectors";
import {getPadForTimer, LANGUAGE_PATH, useTimer} from "modules";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {ReactComponent as TimerSeparator} from "apps/DRAW_PREDICTOR/assets/images/icons/timerSeparator.svg";
import {media} from "assets/css/media";
import {Exist} from "components";

const Label = styled.p`
	font-family: "Qatar2022", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 140%;
	color: #fff;
	text-transform: uppercase;
`;

const Time = styled.div`
	display: flex;
	justify-content: space-between;
	font-family: "Qatar2022", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 20px;
	line-height: 140%;
	color: #fff;
	max-width: 100px;
	margin: 0 auto;
`;

const TimeItem = styled.div`
	text-align: center;
`;

const TimerWrapper = styled.div`
	margin-top: -20px;
	min-width: 125px;
	text-align: center;

	@media (max-width: ${media.mobile}) {
		margin-top: 20px;
	}
`;

const TimerSeparatorStyled = styled(TimerSeparator)`
	margin-top: 8px;
`;

const TimeDesignation = styled.div`
	font-size: 10px;
	margin-top: -7px;
`;

export const PreRegistrationTimer: React.FC = () => {
	const dispatch = useDispatch();
	const settings = useSelector(getDrawPredictorSettings);
	const countdown = useTimer(settings.countdownTimer);
	const isLocked = useSelector(isFullLockout);
	const {t} = useTranslation(LANGUAGE_PATH);
	const [time, setTime] = useState({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
	});

	useEffect(() => {
		dispatch(fetchSettingsJSON());
	}, [dispatch]);

	useEffect(() => {
		if (countdown.isComplete && !isLocked) {
			dispatch(setFullLockout());
		}
	}, [countdown.isComplete, isLocked, dispatch]);

	useEffect(() => {
		const {days, hours, minutes, seconds} = countdown;
		setTime({
			days,
			hours,
			minutes,
			seconds,
		});
	}, [countdown, setTime]);

	return (
		<TimerWrapper>
			<Label>{t("prediction.page.qualifying_countdown")}</Label>
			<Time>
				<Exist when={time.days > 0}>
					<Fragment>
						<TimeItem>
							<div>{getPadForTimer(time.days)}</div>
							<TimeDesignation>DAYS</TimeDesignation>
						</TimeItem>
						<TimerSeparatorStyled />
					</Fragment>
				</Exist>
				<TimeItem>
					<div>{getPadForTimer(time.hours)}</div>
					<TimeDesignation>HRS</TimeDesignation>
				</TimeItem>
				<TimerSeparatorStyled />
				<TimeItem>
					<div>{getPadForTimer(time.minutes)}</div>
					<TimeDesignation>MINS</TimeDesignation>
				</TimeItem>

				<Exist when={time.days === 0}>
					<Fragment>
						<TimerSeparatorStyled />
						<TimeItem>
							<div>{getPadForTimer(time.seconds)}</div>
							<TimeDesignation>SECS</TimeDesignation>
						</TimeItem>
					</Fragment>
				</Exist>
			</Time>
		</TimerWrapper>
	);
};
